export default __webpack_public_path__ + "68ef831d4c15a9d4fa813c4e48281492.svg";